import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row } from 'reactstrap';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { getWishlistOnSale } from 'Redux/ducks/wishlist';
import BrowseButton from 'Components/Utility/BrowseButton';
import WishlistSaleContainer from 'Containers/Wishlist/WishlistSaleContainer';

const messages = defineMessages({
  viewwishlist: {
    id: 'wishlistsale.viewwishlist',
    defaultMessage: 'View Wishlist',
  },
});

const WishlistSaleSection = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const authenticated = useSelector(state => state.auth.authenticated);
  const onSaleWishlist = useSelector(state => state.wishlist.onSaleWishlist);
  const onSaleNbHits = useSelector(state => state.wishlist.onSaleNbHits);
  const wishlistCount = useSelector(state => state.wishlist.count);

  useEffect(() => {
    if (authenticated) {
      dispatch(getWishlistOnSale());
    }
  }, [authenticated, dispatch]);

  if (!authenticated) return false;
  if (!Array.isArray(onSaleWishlist) || onSaleWishlist.length === 0) return false;
  if (onSaleNbHits <= 1) return false;

  return (
    <Row className="homepage-wishlist-section container">
      <div className="container">
        <div className="section-heading-container">
          <div className="d-flex align-items-center">
            <h4 className="m-0">
              <FormattedMessage id="wishlistsale.title" defaultMessage="On Sale on Your Wishlist" />
            </h4>
            <BrowseButton className={'view-all-btn'} location={'wishlist'} btnText={formatMessage(messages.viewwishlist)} />
          </div>
          <div className="wishlist-sale-secondary-text">
            <FormattedMessage
              id="wishlistsale.on-sale-count"
              defaultMessage="{saleGames} of {totalGames} items on your wishlist are on sale"
              values={{
                totalGames: wishlistCount,
                saleGames: onSaleNbHits,
              }}
            />
          </div>
        </div>
        <WishlistSaleContainer shouldFetchHits={false} />
        <p className="wishlist-upsell">
          <b><FormattedMessage id="wishlistsale.assistant.more-deals" defaultMessage="Want to see more personalised deals?" /></b>&nbsp;
          <FormattedMessage
            id="wishlistsale.assistant.update-wishlist"
            defaultMessage="{link} regularly to keep your Fanatical Wishlist up to date."
            values={{
              link: <Link to="/wishlist">
                <FormattedMessage id="wishlistsale.assistant.wishlist-link" defaultMessage="Sync your Steam Wishlist" />
              </Link>,
            }}
          />
        </p>
      </div>
    </Row>
  );
};

export default WishlistSaleSection;
